import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Star, ShieldCheck } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-24 px-6 bg-[#faf9f7]" data-id="element-104">
      <div className="max-w-3xl mx-auto" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-xl overflow-hidden border border-slate-100" data-id="element-106">
          <div className="bg-teal-700 p-4 text-center" data-id="element-107">
            <p className="text-teal-50 font-medium text-sm tracking-wide uppercase" data-id="element-108">
              Limited Time Offer • Save 67%
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-109">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-110">
              Start your reset today
            </h2>
            <p className="text-slate-600 mb-8 max-w-lg mx-auto" data-id="element-111">
              Get the complete protocol, daily trackers, and relapse plan.
              You'll know the routine well enough to use it in real life by the
              end of week one.
            </p>

            <div className="flex items-baseline justify-center gap-2 mb-8" data-id="element-112">
              <span className="text-5xl font-bold text-slate-900" data-id="element-113">$6.50</span>
              <span className="text-slate-400 line-through text-xl" data-id="element-114">
                $19.99
              </span>
            </div>

            <button onClick={() => {
            window.open('https://everydayresets.com/cart/42495476727895:1', '_blank');
          }} className="w-full md:w-auto group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-300 bg-teal-600 rounded-xl hover:bg-teal-700 hover:scale-[1.02] shadow-lg hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 mb-6" data-id="element-115">
              <span data-id="element-116">Get The 14-Day Reset</span>
              <ArrowRight className="w-5 h-5 ml-2 transition-transform duration-300 group-hover:translate-x-1" data-id="element-117" />
            </button>

            <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-slate-500" data-id="element-118">
              <div className="flex items-center gap-1" data-id="element-119">
                <ShieldCheck className="w-4 h-4 text-teal-600" data-id="element-120" />
                <span data-id="element-121">Secure payment</span>
              </div>
              <div className="hidden md:block w-1 h-1 bg-slate-300 rounded-full" data-id="element-122" />
              <div className="flex items-center gap-1" data-id="element-123">
                <Star className="w-4 h-4 text-teal-600" data-id="element-124" />
                <span data-id="element-125">Instant digital download</span>
              </div>
            </div>
          </div>

          <div className="bg-slate-50 p-6 border-t border-slate-100" data-id="element-126">
            <p className="text-center text-slate-500 text-sm italic" data-id="element-127">
              "If you're tired of being the woman who 'handles everything' while
              your body quietly falls apart… start here."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}